// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19.9708 9.0385L3.10742 3.11353L9.0324 19.9769L12.4098 15.2485L18.1833 21.022L21.0117 18.1936L15.2376 12.4194L19.9708 9.0385Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-cursor-filled')
export default class CursorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cursor-filled',
    }
  }
}
